import { createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { addEditTeam, getTeamsByTenant } from "./thunks";

const initialState = {
  teamsByTenant: {},
  loading: true,
};

const teamSlice = createSlice({
  name: "team",
  initialState,
  reducers: {
    setKeyValue: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTeamsByTenant.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTeamsByTenant.fulfilled, (state, action) => {
        const { data, tenant_id } = action.payload;
        state.teamsByTenant[tenant_id] = data;
        state.loading = false;
      })
      .addCase(getTeamsByTenant.rejected, (state) => {
        state.loading = false;
      })
      .addCase(addEditTeam.fulfilled, (state, action) => {
        const team_id = action.meta.arg?.team_id;

        const { data, message: successMessage } = action.payload;

        if (team_id) {
          const tenantUsers = state.teamsByTenant[data?.tenant_id] || [];
          const userIndex = tenantUsers.findIndex(
            (user) => user.id === data.id
          );
          if (userIndex !== -1) {
            tenantUsers[userIndex] = data;
          }
        } else state.teamsByTenant[data?.tenant_id].push(data);

        message.success(successMessage || "Invitation sent successfully");
      });
  },
});

export const { setKeyValue } = teamSlice.actions;

export default teamSlice.reducer;
